import { StoreInterface } from "../../models";

export const getTeams = (state: StoreInterface) => state?.teams?.teams;
export const getTeamUsers = (state: StoreInterface) => state?.teams?.teamUsers;
export const getSelectedTeam = (state: StoreInterface) => state?.teams?.selectedTeam;
export const getSelectedProjectTeam = (state: StoreInterface) => state?.teams?.selectedProjectTeam;
export const getSelectedTeamName = (state: StoreInterface) => state?.teams?.teams?.find((team) => team.id === state?.teams?.selectedProjectTeam)?.name;
export const getMembersIdWithSingleTeam = (state: StoreInterface) => state?.teams?.singleTeamMembersId;
